import Vue from "vue";
import LocomotiveScroll from "~/libs/locomotive-scroll/component/index.vue";

Vue.component("LocomotiveScroll", LocomotiveScroll);
